import React from 'react';
import styled from 'styled-components';

import { Preview } from '../components/Preview';
import { PostPreviewListWrapper } from '../components/Preview/styled';
import SEO from '../components/SEO';

class BlogIndex extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const posts = this.props.data.allContentfulBlogPost.edges;
    const siteMetadata = this.props.data.site.siteMetadata;

    return (
      <div>
        <SEO 
          title={siteMetadata.title}
          description={siteMetadata.description}
          image={siteMetadata.image}
          url={siteMetadata.url}
          twitter={siteMetadata.twitter}
        />
        <PostPreviewListWrapper>
          {posts.map((post, id) => {
            if (post.node.path !== '/404/') {
              const title = post.node.title || post.node.path
              return (
                <Preview 
                  key={id}
                  slug={post.node.slug}
                  category={post.node.category[0].slug}
                  title={post.node.title}
                  avatar={post.node.author[0].avatar.file.url}
                  name={post.node.author[0].name}
                  createdAt={post.node.createdAt}
                  excerpt={post.node.childContentfulBlogPostBodyTextNode.childMarkdownRemark.html}
                />
              )
            }
          })}
        </PostPreviewListWrapper>
      </div>
    )
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default BlogIndex

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        description
        image
        url
        twitter
      }
    }
    allContentfulBlogPost(
      sort: {fields: [timestamp], order: DESC}
    ) {
      edges {
        node {
          slug
          title
          createdAt(formatString: "MMMM DD, YYYY")
          category {
            slug
          }
          author {
            name
            avatar {
              file {
                url
              }
            }
          }
          childContentfulBlogPostBodyTextNode {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js